import React from 'react';

import { Col, Container, Row } from 'reactstrap';

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

import { Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Images
import angithi from "./../../../assets/images/logos/angithi.png"
import bluelines from "./../../../assets/images/logos/bluelines.png"
import br from "./../../../assets/images/logos/br.png"
import galaxy from "./../../../assets/images/logos/Galaxy.png"
import hector from "./../../../assets/images/logos/hector.png"
import jagdamba from "./../../../assets/images/logos/jagdamba.png"
import kalinga from "./../../../assets/images/logos/kalinga.png"
import navdurga from "./../../../assets/images/logos/navdurga.png"
import sarthak from "./../../../assets/images/logos/sarthak.png"
import shriganesh from "./../../../assets/images/logos/shriganesh.png"
import vedanta from "./../../../assets/images/logos/vedanta.png"

const Client = () => {
  return (
    <React.Fragment>
      <div className="pt-5 mt-5">
        <Container>
          <Row>
            <Col lg={12}>

              <div className="text-center mt-5">
                <h5 className="fs-20">Trusted <span className="text-primary text-decoration-underline">by</span> The Industry's Best</h5>
                <Swiper
                  slidesPerView={5}
                  spaceBetween={30}
                  // pagination={{
                  //     clickable: true,
                  // }}
                  pagination={false}
                  breakpoints={{
                    576: {
                      slidesPerView: 3,
                    },
                    768: {
                      slidesPerView: 4,
                    },
                    1024: {
                      slidesPerView: 5,
                    },
                  }}
                  loop={true}
                  autoplay={{ delay: 1000, disableOnInteraction: false }}
                  modules={[Pagination, Autoplay]}
                  className="mySwiper swiper trusted-client-slider mt-sm-3 mt-2 mb-sm-3 mb-2"
                >
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={angithi} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={bluelines} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={br} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={galaxy} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={hector} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={jagdamba} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={kalinga} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={navdurga} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={sarthak} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={shriganesh} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="client-images">
                      <img src={vedanta} alt="client-img" className="mx-auto img-fluid d-block" />
                    </div>
                  </SwiperSlide>
                </Swiper>

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Client;